import { ChangeDetectionStrategy, Component } from '@angular/core';

const DOLPHIN_PATH =
  'M5,45 C15,15 35,2 55,6 L60,-6 L65,8 C75,10 88,16 95,25 C80,30 60,32 45,30 C25,28 12,35 5,45 Z';

/**
 * A small pod of dolphins breaching along the bottom edge of ocean-themed
 * hero sections. Each one bobs continuously (always at least partly visible,
 * peaking into a full breach) rather than doing one rare jump per long cycle,
 * so the pod reads as active from the first frame and the loop seam never
 * shows. Respects prefers-reduced-motion via the global rule in styles.css.
 */
@Component({
  selector: 'app-dolphin-pod',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="dolphin-pod" aria-hidden="true">
      <svg class="dolphin dolphin-1" viewBox="-10 -20 120 80" width="66" height="44">
        <path [attr.d]="dolphinPath" />
      </svg>
      <svg class="dolphin dolphin-2" viewBox="-10 -20 120 80" width="52" height="35">
        <path [attr.d]="dolphinPath" />
      </svg>
      <svg class="dolphin dolphin-3" viewBox="-10 -20 120 80" width="58" height="39">
        <path [attr.d]="dolphinPath" />
      </svg>
    </div>
  `,
  styles: [
    `
      :host {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 170px;
        pointer-events: none;
        overflow: hidden;
      }
      .dolphin-pod {
        position: absolute;
        inset: 0;
      }
      .dolphin {
        position: absolute;
        bottom: 22px;
        fill: var(--color-paper);
        opacity: 0.55;
        filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.35));
        transform-origin: 50% 100%;
        animation: dolphin-jump 4.2s ease-in-out infinite;
      }
      .dolphin-1 {
        left: 12%;
        animation-duration: 4.6s;
      }
      .dolphin-2 {
        left: 45%;
        animation-duration: 3.8s;
        animation-delay: -1.5s;
      }
      .dolphin-3 {
        left: 68%;
        animation-duration: 5.1s;
        animation-delay: -3s;
      }
      @keyframes dolphin-jump {
        0%,
        100% {
          transform: translateY(22px) scale(0.82);
          opacity: 0.45;
        }
        50% {
          transform: translateY(-42px) rotate(-8deg) scale(1);
          opacity: 1;
        }
      }
    `,
  ],
})
export class DolphinPod {
  dolphinPath = DOLPHIN_PATH;
}
